import { FluentBundle } from 'fluent';
import { GetString } from 'fluent-react';
import React from 'react';
import styled from 'styled-components';
import {
  PolicyDimension,
} from '../Utils';
import PolicyDimensionRadioButton from './PolicyDimensionRadioButton';
import SectionLabel from './SectionLabel';

const Container = styled.div`
  grid-row: 2;
  grid-column: 2;
`;

interface Props {
  policyDimension: PolicyDimension;
  setPolicyDimension: (value: PolicyDimension) => void;
  getFluentString: GetString;
  fluentBundle: FluentBundle;
}

const PolicyDimensionSelect = (props: Props) => {

  const {
    policyDimension, setPolicyDimension,
    getFluentString, fluentBundle,
  } = props;
  const labelTextArg: string[] = [
    'policy-dimensions-control-radio-label-low-hanging-fruit',
    'policy-dimensions-control-radio-label-balanced-portfolio',
    'policy-dimensions-control-radio-label-long-jumps',
  ];
  const tooltipTextArg: string[] = [
    'policy-dimensions-control-radio-label-low-hanging-fruit-tooltip-content',
    'policy-dimensions-control-radio-label-balanced-portfolio-tooltip-content',
    'policy-dimensions-control-radio-label-long-jumps-tooltip-content',
  ];
  const emphasizedTextArg: string[] = [
    getFluentString('policy-dimensions-control-radio-label-closer'),
    '',
    getFluentString('policy-dimensions-control-radio-label-further'),
  ];
  const labelIds: PolicyDimension[] = [
    PolicyDimension.LowHangingFruit,
    PolicyDimension.BalancedPortfolio,
    PolicyDimension.LongJump,
  ];

  const buttonsArr: Array<React.ReactElement<any>> = [];
  for (let i = 0; i < labelTextArg.length; i++) {
    buttonsArr.push(
      <PolicyDimensionRadioButton
        selectedValue={policyDimension}
        elmValue={labelIds[i]}
        setValue={setPolicyDimension}
        labelTextArg={labelTextArg[i]}
        tooltipTextArg={tooltipTextArg[i]}
        emphasizedTextArg={emphasizedTextArg[i]}
        getFluentString={getFluentString}
        fluentBundle={fluentBundle}
        key={labelIds[i]}
      />,
    );
  }

  return (
    <>
      <SectionLabel
        num={2}
        title={getFluentString('policy-dimensions-control-title-text-2')}
      />
      <Container>
        {buttonsArr}
      </Container>
    </>
  );
};

export default PolicyDimensionSelect;
